<template>
    <div class="wo-maintenance" v-if="displaySchedule">
        <div class="modal-header" v-if="from != undefined && from == 'fuel'">
            <h5 class="modal-title">Maintenance For: <span v-if="scheduleMaintenanceArr && scheduleMaintenanceArr.length > 0">{{scheduleMaintenanceArr[0].vUnitNo}}</span></h5>
        </div>

        <div class="modal-body">

            <p v-if="scheduleMaintenanceArr && scheduleMaintenanceArr.length > 0">The following Program exist on the work roster</p>
            <template v-if="scheduleMaintenanceArr && scheduleMaintenanceArr.length > 0">
                <h5 class="mb-2">Due:</h5>
                <template v-for="(main,mKey) in scheduleMaintenanceArr">
                    <div :key="mKey" class="form-group mb-3">
                        <div class="custom-checkbox">
                            <label class="checkbox-custom">
                                {{main.program}}
                                <!-- <input type="checkbox" @change="selectMaintenance(main,$event,'program')"/> -->
                                <!-- <span class="checkmark"></span> -->
                            </label>
                        </div>
                    </div>
                </template>

                <br>
            </template>
            <!-- <p v-if="warrantyTriggerArr && warrantyTriggerArr.length > 0">The following Warranty exist on the work roster.</p>
            <template v-if="warrantyTriggerArr && warrantyTriggerArr.length > 0">
                <h5 class="mb-2">Due:</h5>
                <template v-for="(war,wKey) in warrantyTriggerArr">
                    <div :key="wKey" class="form-group mb-3">
                        <div class="custom-checkbox">
                            <label class="checkbox-custom">
                                {{war.warranty}}
                            </label>
                        </div>
                    </div>
                </template>
                <div v-if="dueNotFound">
                    <span>&nbsp;&nbsp; No Due Found.</span>
                </div>
                <br>
            </template> -->
        </div>
        <div class="modal-footer btm-action-btn-fl">
            <button class="btn btn-primary" v-if="from != undefined && from == 'fuel'" id="importFileBtn" v-on:click="$parent.CreateFuelTicket(passingFlag)"> <i class="fp-submit"> </i> Continue</button>
            <button class="btn btn-primary" v-else id="importFileBtn" v-on:click="$parent.checkTriggers('no_program')"> <i class="fp-submit"> </i> Continue</button>
            <!-- <button type="button" class="btn btn-secondary" v-on:click="redirectToItem">SKIP</button> -->
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {
    commonMixins
} from '../mixins/commonMixins';
import {
    contractMixins
} from '../mixins/contractMixins';

import moment from 'moment';

export default {
    name: "ProgramTrigger",


    mixins: [commonMixins, contractMixins],
    props: {
      from: {
          type: String,
          required: true,
          default:undefined
      }
    },
    data: () => ({

        programArr:[],
        woidForprogram:0,
        selectedProgramArr:[],
        warrantyTriggerArr:[],
        warArr:[],
        displaySchedule:false,
        dueNotFound:'',
        passingFlag:'no_program',
    }),
    created: function () {

    },
    mounted: function () {

        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        //on click enter click on continue button
        window.addEventListener('keyup', event => {
            if (event.key === 'Enter' && self.$parent.currentFlag != 'save_and_continue_from_trigger') {
                $("#importFileBtn").click();
            }
        })

    },
    methods: {
        getMappedProgram(v_id,miles,open_date,flag=null) {
            var self = this;

            self.$parent.loading = true;
            if (flag !== null){
              self.passingFlag = 'save_and_continue_from_trigger';
            }
            $.ajax({
                url: process.env.ROOT_API + "/mapped-program/fetch",
                type: "GET",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType: "json",
                data: {
                    vehicle_id: v_id,
                    flag:'wo',
                    miles:miles,
                    open_date:open_date
                },
                success: function (data) {
                    self.$parent.loading = false;
                    self.scheduleMaintenanceArr = [];
                    if (data.code == 200) {

                        console.log(JSON.stringify(data));
                        if ( data.content.program != undefined && data.content.program.length > 0){

                            self.scheduleMaintenanceArr = data.content.program;
                            // self.woidForprogram = woid;

                            self.displaySchedule = true;
                            self.$parent.displaySchedule = true;
                            $("#trigger-message-modal").modal("show");

                        }else{
                            self.$parent.displaySchedule = false;
                            if (self.from != undefined && self.from == 'fuel'){
                                self.$parent.CreateFuelTicket('no_program');
                            }else{

                                self.$parent.checkTriggers('no_program');

                            }
                        }

                        // $("#myModal").modal('show');

                    }else{
                        self.$parent.displaySchedule = false;
                        if (self.from != undefined && self.from == 'fuel'){
                            self.$parent.CreateFuelTicket('no_program');
                        }else{

                            self.$parent.checkTriggers('no_program');

                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'get-scheduled-maintenance');
                }
            });

        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/ProgramTrigger.vue